import { TrashIcon, type IconT } from '@mentimeter/ragnar-visuals';
import type { IconButtonProps } from '@mentimeter/ragnar-ui/icon-button';
import { IconButton } from '@mentimeter/ragnar-ui/icon-button';
import { useTranslations } from 'next-intl';
import { usePresentationContext } from '../../../../legacy-context/presentationContext';

interface Props extends IconButtonProps {
  iconSize?: IconT['size'];
  selectedAnswer: string;
}

export const ModerationButton = ({ selectedAnswer, ...rest }: Props) => {
  const { useModeration } = usePresentationContext();
  const { showUi, toggleWord } = useModeration();

  return showUi && selectedAnswer ? (
    <ModerationButtonUI onClick={() => toggleWord(selectedAnswer)} {...rest} />
  ) : null;
};

interface UIProps extends IconButtonProps {
  iconSize?: IconT['size'];
}

const ModerationButtonUI = ({ iconSize = 3, ...rest }: UIProps) => {
  const translate = useTranslations('presenting.legacy');

  return (
    <IconButton
      size="large"
      variant="secondary"
      borderRadius="medium"
      bg="transparent"
      color="inherit"
      aria-label={translate('actions.delete_answer')}
      {...rest}
    >
      <TrashIcon size={iconSize} color="inherit" />
    </IconButton>
  );
};
